app.controller('goldWizardCheckController', function ($rootScope, $scope, safeApply, checksBalancesService) {

  init()

  async function init() {
    // load gold wizard check data from wizards_gold
    console.log("goldWizardCheckController")
  }

  $scope.runProcess = async function () {
    let getGoldWizardRecordsResults = await checksBalancesService.getGoldWizardRecords({ tax_year: 2022 })
    console.log('getGoldWizardRecordsResults :>> ', getGoldWizardRecordsResults);
  }

})